import { Skeleton, Stack } from '@mui/material';

import { AddCampusCard } from './AddCampusCard';
import { AddPaymentMethod } from './AddPaymentMethod';
import { AvailableSwapStep } from './AvailableSwapStep';
import { CampusCardSection } from './CampusCardSection';
import { FUZECashBalanceInCurrencies } from './FUZECashBalanceInCurrencies';
import { PassDetailStep } from './PassDetailStep';
import { PromoCodeStep } from './PromoCodeStep';
import { RentChargerStep } from './RentChargerStep';
import { SelectPaymentMethod } from './SelectPaymentMethod';
import { SelectRentalOptionStep } from './SelectRentalOptionStep';

import { PAYMENT_STEP } from '~common';
import { PassStatusBanner } from '~components/molecules/pass/PassStatusBanner';
import {
  AccountBalancesProvider,
  usePaymentStepContext,
  useStationPricingContext,
} from '~providers';

export const StepThree = () => {
  const { isLoadingStationPricing } = useStationPricingContext();
  const { paymentStep } = usePaymentStepContext();

  if (isLoadingStationPricing) {
    return (
      <Stack>
        <Skeleton variant="rectangular" height={100} />
        <Skeleton variant="rectangular" height={100} />
        <Skeleton variant="rectangular" height={100} />
      </Stack>
    );
  }

  return (
    <AccountBalancesProvider>
      {/* A pass that exists but can't be redeemed here and now must never look
          like "you have no pass" — say why above the pay-per-use steps. */}
      {(paymentStep === PAYMENT_STEP.SELECT_PRICING_MODELS ||
        paymentStep === PAYMENT_STEP.RENT_A_CHARGER) && <PassStatusBanner />}

      {paymentStep === PAYMENT_STEP.SELECT_PRICING_MODELS && (
        <SelectRentalOptionStep />
      )}
      {paymentStep === PAYMENT_STEP.AVAILABLE_SWAPS && <AvailableSwapStep />}
      {paymentStep === PAYMENT_STEP.SELECT_PAYMENT_METHOD && (
        <SelectPaymentMethod />
      )}
      {paymentStep === PAYMENT_STEP.ADD_PAYMENT_METHOD && <AddPaymentMethod />}
      {paymentStep === PAYMENT_STEP.CAMPUS_CARD_LIST && <CampusCardSection />}
      {paymentStep === PAYMENT_STEP.ADD_CAMPUS_CARD && <AddCampusCard />}
      {paymentStep === PAYMENT_STEP.RENT_A_CHARGER && <RentChargerStep />}
      {paymentStep === PAYMENT_STEP.PASS_DETAIL && <PassDetailStep />}
      {paymentStep === PAYMENT_STEP.ADD_PROMO_CODE && <PromoCodeStep />}
      {paymentStep === PAYMENT_STEP.FUZE_CASH_BALANCES && (
        <FUZECashBalanceInCurrencies />
      )}
    </AccountBalancesProvider>
  );
};
